import { apiUrl } from 'config';

export default function createApiClient() {
  const getPromises = {};

  const headers = {};

  function formatApiUrl(path) {
    return /^http/.test(path) ? path : `${apiUrl}${path[0] !== '/' ? '/' + path : path}`;
  }

  function checkStatus(response) {
    return response.status >= 200 && response.status < 300
      ? response
      : response.json().then(json => Promise.reject(json));
  }

  function handleFailure(error) {
    return Promise.reject(error);
  }

  function fetchCreator(method) {
    return function(url, data, reqOptions = {}) {
      const options = {
        ...reqOptions,
        headers: {
          Accept: 'application/json',
          ...headers,
          ...(reqOptions.headers || {})
        }
      };

      if (data) {
        if (options.type === 'formData') {
          options.body = new FormData();

          for (let key in data) {
            if (
              typeof key === 'string' &&
              data.hasOwnProperty(key) &&
              typeof data[key] !== 'undefined'
            ) {
              options.body.append(key, data[key]);
            }
          }
        } else {
          options.body = JSON.stringify(data);
          if (!!!options.headers['Content-Type'])
            options.headers['Content-Type'] = 'application/json';
        }
      }

      options.method = method;

      return fetch(formatApiUrl(url), options)
        .then(checkStatus)
        .catch(handleFailure);
    };
  }

  const rawGet = fetchCreator('get');

  function get(url, options) {
    const key = `${url}/${JSON.stringify(options)}`;

    if (getPromises[key]) {
      return getPromises[key];
    }

    const promise = new Promise(async (resolve, reject) => {
      try {
        const response = await rawGet(url);
        const json = await response.json();

        if (getPromises[key]) {
          delete getPromises[key];
        }

        resolve({
          headers: response.headers,
          body: json,
          status: 'ok'
        });
      } catch (error) {
        reject({
          error,
          status: 'failed',
          statusCode: error.status_code
        });
      }
    });

    getPromises[key] = promise;

    return promise;
  }

  return {
    copy: fetchCreator('COPY'),
    delete: fetchCreator('delete'),
    get,
    headers,
    patch: fetchCreator('patch'),
    post: fetchCreator('post'),
    put: fetchCreator('put'),
    rawGet
  };
}
